const MAP = {
  sent:        { bg: "bg-blue-50",   text: "text-blue-700",   border: "border-blue-200" },
  scheduled:   { bg: "bg-amber-50",  text: "text-amber-700",  border: "border-amber-200" },
  sending:     { bg: "bg-violet-50", text: "text-violet-700", border: "border-violet-200" },
  draft:       { bg: "bg-zinc-100",  text: "text-zinc-700",   border: "border-zinc-200" },
  opened:      { bg: "bg-emerald-50",text: "text-emerald-700",border: "border-emerald-200" },
  clicked:     { bg: "bg-violet-50", text: "text-violet-700", border: "border-violet-200" },
  bounced:     { bg: "bg-rose-50",   text: "text-rose-700",   border: "border-rose-200" },
  unsubscribed:{ bg: "bg-amber-50",  text: "text-amber-700",  border: "border-amber-200" },
  failed:      { bg: "bg-rose-50",   text: "text-rose-700",   border: "border-rose-200" },
  stopped:     { bg: "bg-rose-50",   text: "text-rose-700",   border: "border-rose-200" },
  active:      { bg: "bg-emerald-50",text: "text-emerald-700",border: "border-emerald-200" },
  left_company:{ bg: "bg-orange-50", text: "text-orange-700", border: "border-orange-200" },
  lead:        { bg: "bg-zinc-100",  text: "text-zinc-700",   border: "border-zinc-200" },
  qualified:   { bg: "bg-blue-50",   text: "text-blue-700",   border: "border-blue-200" },
  customer:    { bg: "bg-emerald-50",text: "text-emerald-700",border: "border-emerald-200" },
  opportunity: { bg: "bg-violet-50", text: "text-violet-700", border: "border-violet-200" },
};

const LABELS = { left_company: "no longer at company" };

export const StatusBadge = ({ value }) => {
  const v = (value || "").toLowerCase();
  const s = MAP[v] || MAP.draft;
  return (
    <span className={`inline-flex items-center rounded-full border px-2 py-0.5 text-[11px] font-medium whitespace-nowrap ${s.bg} ${s.text} ${s.border}`}>
      {LABELS[v] || v}
    </span>
  );
};
